export const LOGIN_MODAL = 'LOGIN_MODAL'
export const SIGNUP_MODAL = 'SIGNUP_MODAL'
export const PLAYLIST_MODAL = 'PLAYLIST_MODAL'
export const PREVIEW_MODAL = 'PREVIEW_MODAL'

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const SEARCH_KEYWORD_REQUEST = 'SEARCH_KEYWORD_REQUEST'
export const SEARCH_KEYWORD_SUCCESS = 'SEARCH_KEYWORD_SUCCESS'
export const SEARCH_KEYWORD_FAILURE = 'SEARCH_KEYWORD_FAILURE'


export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

export const FETCH_SUCCESS = 'FETCH_SUCCESS'
export const FETCH_ERROR = 'FETCH_ERROR'

export const SUBMIT_REVIEWS = 'SUBMIT_REVIEWS'

export const LOAD_INFO_SETTING_PAGES_REQUEST = 'LOAD_INFO_SETTING_PAGES_REQUEST'
export const LOAD_INFO_SETTING_PAGES_SUCCESS = 'LOAD_INFO_SETTING_PAGES_SUCCESS'
export const LOAD_INFO_SETTING_PAGES_FAILURE = 'LOAD_INFO_SETTING_PAGES_FAILURE'

export const LOAD_ALL_INTERESTS_REQUEST = 'LOAD_ALL_INTERESTS_REQUEST'
export const LOAD_ALL_INTERESTS_SUCCESS = 'LOAD_ALL_INTERESTS_SUCCESS'
export const LOAD_ALL_INTERESTS_FAILURE = 'LOAD_ALL_INTERESTS_FAILURE'

export const UPDATE_INTERESTS_REQUEST = 'UPDATE_INTERESTS_REQUEST'
export const UPDATE_INTERESTS_SUCCESS = 'UPDATE_INTERESTS_SUCCESS'
export const UPDATE_INTERESTS_FAILURE = 'UPDATE_INTERESTS_FAILURE'

export const LOAD_HOME_PAGES_SIDE_REQUEST = 'LOAD_HOME_PAGES_SIDE_REQUEST'
export const LOAD_HOME_PAGES_SIDE_SUCCESS = 'LOAD_HOME_PAGES_SIDE_SUCCESS'
export const LOAD_HOME_PAGES_SIDE_FAILURE = 'LOAD_HOME_PAGES_SIDE_FAILURE'

export const LOAD_HOME_PAGES_ALL_REQUEST = 'LOAD_HOME_PAGES_ALL_REQUEST'
export const LOAD_HOME_PAGES_ALL_SUCCESS = 'LOAD_HOME_PAGES_ALL_SUCCESS'
export const LOAD_HOME_PAGES_ALL_FAILURE = 'LOAD_HOME_PAGES_ALL_FAILURE'

export const LOAD_PROFILE_PAGES_REQUEST = 'LOAD_PROFILE_PAGES_REQUEST'
export const LOAD_PROFILE_PAGES_SUCCESS = 'LOAD_PROFILE_PAGES_SUCCESS'
export const LOAD_PROFILE_PAGES_FAILURE = 'LOAD_PROFILE_PAGES_FAILURE'

export const LOAD_PROFILE_PRODUCTS_REQUEST = 'LOAD_PROFILE_PRODUCTS_REQUEST'
export const LOAD_PROFILE_PRODUCTS_SUCCESS = 'LOAD_PROFILE_PRODUCTS_SUCCESS'
export const LOAD_PROFILE_PRODUCTS_FAILURE = 'LOAD_PROFILE_PRODUCTS_FAILURE'

export const LOAD_LEVEL_REQUEST = 'LOAD_LEVEL_REQUEST'
export const LOAD_LEVEL_SUCCESS = 'LOAD_LEVEL_SUCCESS'
export const LOAD_LEVEL_FAILURE = 'LOAD_LEVEL_FAILURE'

export const LOAD_CATEGORY_REQUEST = 'LOAD_CATEGORY_REQUEST'
export const LOAD_CATEGORY_SUCCESS = 'LOAD_CATEGORY_SUCCESS'
export const LOAD_CATEGORY_FAILURE = 'LOAD_CATEGORY_FAILURE'

export const UPDATE_FOLLOW_REQUEST = 'UPDATE_FOLLOW_REQUEST'
export const UPDATE_FOLLOW_SUCCESS = 'UPDATE_FOLLOW_SUCCESS'
export const UPDATE_FOLLOW_FAILURE = 'UPDATE_FOLLOW_FAILURE'

export const UPDATE_INFO_REQUEST = 'UPDATE_INFO_REQUEST'
export const UPDATE_INFO_SUCCESS = 'UPDATE_INFO_SUCCESS'
export const UPDATE_INFO_FAILURE = 'UPDATE_INFO_FAILURE'

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE'

export const UPLOAD_USER_IMG_REQUEST = 'UPLOAD_USER_IMG_REQUEST'
export const UPLOAD_USER_IMG_SUCCESS = 'UPLOAD_USER_IMG_SUCCESS'
export const UPLOAD_USER_IMG_FAILURE = 'UPLOAD_USER_IMG_FAILURE'

export const LOAD_COURSE_PAGES_REQUEST = 'LOAD_COURSE_PAGES_REQUEST'
export const LOAD_COURSE_PAGES_SUCCESS = 'LOAD_COURSE_PAGES_SUCCESS'
export const LOAD_COURSE_PAGES_FAILURE = 'LOAD_COURSE_PAGES_FAILURE'

export const LOAD_ALLCREATORS_PAGES_REQUEST = 'LOAD_ALLCREATORS_PAGES_REQUEST'
export const LOAD_ALLCREATORS_PAGES_SUCCESS = 'LOAD_ALLCREATORS_PAGES_SUCCESS'
export const LOAD_ALLCREATORS_PAGES_FAILURE = 'LOAD_ALLCREATORS_PAGES_FAILURE'


export const LOAD_DASHBOARD_REQUEST = 'LOAD_DASHBOARD_REQUEST'
export const LOAD_DASHBOARD_SUCCESS = 'LOAD_DASHBOARD_SUCCESS'
export const LOAD_DASHBOARD_FAILURE = 'LOAD_DASHBOARD_FAILURE'

export const CHANGE_MEDIA_QUERY = 'CHANGE_MEDIA_QUERY'
export const CANCLE_ERROR = 'CANCLE_ERROR'

export const PAUSE_PROMOTIONAL_PLAYER = 'PAUSE_PROMOTIONAL_PLAYER'
export const PLAY_PROMOTIONAL_PLAYER = 'PLAY_PROMOTIONAL_PLAYER'

export const PAUSE_PREVIEW_PLAYER = 'PAUSE_PREVIEW_PLAYER'
export const PLAY_PREVIEW_PLAYER = 'PLAY_PREVIEW_PLAYER'

export const CHANGE_VIDEO_PLAYER = 'CHANGE_VIDEO_PLAYER'
export const LOAD_PLAYLISTS_PLAYER = 'LOAD_PLAYLISTS_PLAYER'
export const LOAD_STATUS_PLAYER = 'LOAD_STATUS_PLAYER'

export const SUBMIT_REVIEW_REQUEST = 'SUBMIT_REVIEW_REQUEST'
export const SUBMIT_REVIEW_SUCCESS = 'SUBMIT_REVIEW_SUCCESS'
export const SUBMIT_REVIEW_FAILURE = 'SUBMIT_REVIEW_FAILURE'

export const DELETE_REVIEW_REQUEST = 'DELETE_REVIEW_REQUEST'
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS'
export const DELETE_REVIEW_FAILURE = 'DELETE_REVIEW_FAILURE'

export const CANCEL_REVIEW_DIALOG = 'CANCEL_REVIEW_DIALOG'

export const CANCEL_REMOVE_REVIEW_DIALOG = 'CANCEL_REMOVE_REVIEW_DIALOG'

export const PAYMENT_REQUEST = 'PAYMENT_REQUEST'
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE'

export const ADD_WISHLIST_REQUEST = 'ADD_WISHLIST_REQUEST'
export const ADD_WISHLIST_SUCCESS = 'ADD_WISHLIST_SUCCESS'
export const ADD_WISHLIST_FAILURE = 'ADD_WISHLIST_FAILURE'

export const SEND_CONTACT_REQUEST = 'SEND_CONTACT_REQUEST'
export const SEND_CONTACT_SUCCESS = 'SEND_CONTACT_SUCCESS'
export const SEND_CONTACT_FAILURE = 'SEND_CONTACT_FAILURE'

export const VERIFY_REQUEST = 'VERIFY_REQUEST'
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS'
export const VERIFY_FAILURE = 'VERIFY_FAILURE'

export const VARIFY_IMAGE_REQUEST = 'VARIFY_IMAGE_REQUEST'
export const VARIFY_IMAGE_SUCCESS = 'VARIFY_IMAGE_SUCCESS'
export const VARIFY_IMAGE_FAILURE = 'VARIFY_IMAGE_FAILURE'

export const CHECK_ACTIVE_REQUEST = 'CHECK_ACTIVE_REQUEST'
export const CHECK_ACTIVE_SUCCESS = 'CHECK_ACTIVE_SUCCESS'
export const CHECK_ACTIVE_FAILURE = 'CHECK_ACTIVE_FAILURE'

export const UPLOAD_IMAGE_COURSE_REQUEST = 'UPLOAD_IMAGE_COURSE_REQUEST'
export const UPLOAD_IMAGE_COURSE_SUCCESS = 'UPLOAD_IMAGE_COURSE_SUCCESS'
export const UPLOAD_IMAGE_COURSE_FAILURE = 'UPLOAD_IMAGE_COURSE_FAILURE'

export const LOAD_INFO_DASHBOARD_REQUEST = 'LOAD_INFO_DASHBOARD_REQUEST'
export const LOAD_INFO_DASHBOARD_SUCCESS = 'LOAD_INFO_DASHBOARD_SUCCESS'
export const LOAD_INFO_DASHBOARD_FAILURE = 'LOAD_INFO_DASHBOARD_FAILURE'

export const CREATE_SECTION = 'CREATE_SECTION'
export const REMOVE_SECTION = 'REMOVE_SECTION'
export const CREATE_LECTION = 'CREATE_LECTION'
export const REMOVE_LECTURE = 'REMOVE_LECTURE'
export const UPDATE_LOCATION_SECTION = 'UPDATE_LOCATION_SECTION'
export const UPDATE_LOCATION_LECTURE = 'UPDATE_LOCATION_LECTURE'
export const LOAD_BANNER_DASHBOARD_SUCCESS = 'LOAD_BANNER_DASHBOARD_SUCCESS'

export const ACTIVE_COURSE_REQUEST = 'ACTIVE_COURSE_REQUEST'
export const ACTIVE_COURSE_SUCCESS = 'ACTIVE_COURSE_SUCCESS'
export const ACTIVE_COURSE_FAILURE = 'ACTIVE_COURSE_FAILURE'

export const LOAD_PRICE_LIST_REQUEST = 'LOAD_PRICE_LIST_REQUEST'
export const LOAD_PRICE_LIST_SUCCESS = 'LOAD_PRICE_LIST_SUCCESS'
export const LOAD_PRICE_LIST_FAILURE = 'LOAD_PRICE_LIST_FAILURE'

export const APPEND_VIDEO_CREATE_COURSE = 'APPEND_VIDEO_CREATE_COURSE'
export const DETACH_VIDEO_CREATE_COURSE = 'DETACH_VIDEO_CREATE_COURSE'
export const UPLOAD_NEW_COURSE = 'UPLOAD_NEW_COURSE'

export const UPDATE_COURSE_LANDING = 'UPDATE_COURSE_LANDING'

export const UPDATE_COURSE_PRICING = 'UPDATE_COURSE_PRICING'

export const UPDATE_ERROR_STATUS = 'UPDATE_ERROR_STATUS'

export const UPDATE_STEP_CUREENT = 'UPDATE_STEP_CUREENT'
export const UPDATE_FILE_LANDING = 'UPDATE_FILE_LANDING'
export const UPLOADING_FILE_COURSE = 'UPLOADING_FILE_COURSE'

export const EDIT_COURSE_REQUEST = 'EDIT_COURSE_REQUEST'
export const EDIT_COURSE_SUCCESS = 'EDIT_COURSE_SUCCESS'
export const EDIT_COURSE_FAILURE = 'EDIT_COURSE_FAILURE'

export const RESET_ALERT = 'RESET_ALERT'

export const LOAD_PROVINCE_REQUEST = 'LOAD_PROVINCE_REQUEST'
export const LOAD_PROVINCE_SUCCESS = 'LOAD_PROVINCE_SUCCESS'
export const LOAD_PROVINCE_FAILURE = 'LOAD_PROVINCE_FAILURE'

export const LOAD_PROVINCESCHOOL_REQUEST = 'LOAD_PROVINCESCHOOL_REQUEST'
export const LOAD_PROVINCESCHOOL_SUCCESS = 'LOAD_PROVINCESCHOOL_SUCCESS'
export const LOAD_PROVINCESCHOOL_FAILURE = 'LOAD_PROVINCESCHOOL_FAILURE'

export const LOAD_AMPHURES_REQUEST = 'LOAD_AMPHURES_REQUEST'
export const LOAD_AMPHURES_SUCCESS = 'LOAD_AMPHURES_SUCCESS'
export const LOAD_AMPHURES_FAILURE = 'LOAD_AMPHURES_FAILURE'

export const SELECT_PROVINCE = 'SELECT_PROVINCE'
export const RESET_PROVINCE = 'RESET_PROVINCE'

export const CREATE_CONTACTSTAFF_REQUEST = 'CREATE_CONTACTSTAFF_REQUEST'
export const CREATE_CONTACTSTAFF_SUCCESS = 'CREATE_CONTACTSTAFF_SUCCESS'
export const CREATE_CONTACTSTAFF_FAILURE = 'CREATE_CONTACTSTAFF_FAILURE'

export const LOAD_BANNER_REQUEST = 'LOAD_BANNER_REQUEST'
export const LOAD_BANNER_SUCCESS = 'LOAD_BANNER_SUCCESS'
export const LOAD_BANNER_FAILURE = 'LOAD_BANNER_FAILURE'

export const LOAD_EXAMPLE_SUCCESS = 'LOAD_EXAMPLE_SUCCESS'
export const CHANGE_EXAMPLE_SUCCESS = 'CHANGE_EXAMPLE_SUCCESS'
export const CREATE_EXAM_SUCCESS = 'CREATE_EXAM_SUCCESS'
export const CHOOSE_EXAM_SUCCESS = 'CHOOSE_EXAM_SUCCESS'

export const LOAD_CATEGORYEXAM_REQUEST = 'LOAD_CATEGORYEXAM_REQUEST'
export const LOAD_CATEGORYEXAM_SUCCESS = 'LOAD_CATEGORYEXAM_SUCCESS'
export const LOAD_CATEGORYEXAM_FAILURE = 'LOAD_CATEGORYEXAM_FAILURE'

export const LOAD_LISTEXAM_REQUEST = 'LOAD_LISTEXAM_REQUEST'
export const LOAD_LISTEXAM_SUCCESS = 'LOAD_LISTEXAM_SUCCESS'
export const LOAD_LISTEXAM_FAILURE = 'LOAD_LISTEXAM_FAILURE'

export const SAVE_SECTION_SUCCESS = 'SAVE_SECTION_SUCCESS'

export const LOAD_EXAMOVERVIEW_REQUEST = 'LOAD_EXAMOVERVIEW_REQUEST'
export const LOAD_EXAMOVERVIEW_SUCCESS = 'LOAD_EXAMOVERVIEW_SUCCESS'
export const LOAD_EXAMOVERVIEW_FAILURE = 'LOAD_EXAMOVERVIEW_FAILURE'

export const LOAD_SUBCATEGORYEXAM_REQUEST = 'LOAD_SUBCATEGORYEXAM_REQUEST'
export const LOAD_SUBCATEGORYEXAM_SUCCESS = 'LOAD_SUBCATEGORYEXAM_SUCCESS'
export const LOAD_SUBCATEGORYEXAM_FAILURE = 'LOAD_SUBCATEGORYEXAM_FAILURE'

export const SET_TIMER_SUCCESS = 'SET_TIMER_SUCCESS'
export const SET_TIMESTART_SUCCESS = 'SET_TIMESTART_SUCCESS'

export const SUBMIT_ANSWER_REQUEST = 'SUBMIT_ANSWER_REQUEST'
export const SUBMIT_ANSWER_SUCCESS = 'SUBMIT_ANSWER_SUCCESS'
export const SUBMIT_ANSWER_FAILURE = 'SUBMIT_ANSWER_FAILURE'

export const SUBMIT_REVIEWEXAM_REQUEST = 'SUBMIT_REVIEWEXAM_REQUEST'
export const SUBMIT_REVIEWEXAM_SUCCESS = 'SUBMIT_REVIEWEXAM_SUCCESS'
export const SUBMIT_REVIEWEXAM_FAILURE = 'SUBMIT_REVIEWEXAM_FAILURE'

export const DELETE_REVIEWEXAM_REQUEST = 'DELETE_REVIEWEXAM_REQUEST'
export const DELETE_REVIEWEXAM_SUCCESS = 'DELETE_REVIEWEXAM_SUCCESS'
export const DELETE_REVIEWEXAM_FAILURE = 'DELETE_REVIEWEXAM_FAILURE'

export const LOAD_QUESTIONEXAM_REQUEST = 'LOAD_QUESTIONEXAM_REQUEST'
export const LOAD_QUESTIONEXAM_SUCCESS = 'LOAD_QUESTIONEXAM_SUCCESS'
export const LOAD_QUESTIONEXAM_FAILURE = 'LOAD_QUESTIONEXAM_FAILURE'

export const SAVE_EXAMPLE_SUCCESS = 'SAVE_EXAMPLE_SUCCESS'
export const CREATE_VIDEO_SUCCESS = 'CREATE_VIDEO_SUCCESS'

export const RESET_STATUS_RESPONSE = 'RESET_STATUS_RESPONSE'

export const LOAD_SCHOOL_REQUEST = 'LOAD_SCHOOL_REQUEST'
export const LOAD_SCHOOL_SUCCESS = 'LOAD_SCHOOL_SUCCESS'
export const LOAD_SCHOOL_FAILURE = 'LOAD_SCHOOL_FAILURE'

export const LOAD_SCHOOLGET_REQUEST = 'LOAD_SCHOOLGET_REQUEST'
export const LOAD_SCHOOLGET_SUCCESS = 'LOAD_SCHOOLGET_SUCCESS'
export const LOAD_SCHOOLGET_FAILURE = 'LOAD_SCHOOLGET_FAILURE'
export const GET_COIN_REQUEST = 'GET_COIN_REQUEST'
export const GET_COIN_SUCCESS = 'GET_COIN_SUCCESS'
export const GET_COIN_FAILURE = 'GET_COIN_FAILURE'

export const LOAD_COIN_REQUEST = 'LOAD_COIN_REQUEST'
export const LOAD_COIN_SUCCESS = 'LOAD_COIN_SUCCESS'
export const LOAD_COIN_FAILURE = 'LOAD_COIN_FAILURE'

export const SET_EXAMPLE_SUCCESS = 'SET_EXAMPLE_SUCCESS'

export const REGISTER_NEWUSER_REQUEST = 'REGISTER_NEWUSER_REQUEST'
export const REGISTER_NEWUSER_SUCCESS = 'REGISTER_NEWUSER_SUCCESS'
export const REGISTER_NEWUSER_FAILURE = 'REGISTER_NEWUSER_FAILURE'

export const SAVE_MERGE_REQUEST = 'SAVE_MERGE_REQUEST'
export const SAVE_MERGE_SUCCESS = 'SAVE_MERGE_SUCCESS'
export const SAVE_MERGE_FAILURE = 'SAVE_MERGE_FAILURE'

export const MERGE_REQUEST = 'MERGE_REQUEST'
export const MERGE_SUCCESS = 'MERGE_SUCCESS'
export const MERGE_FAILURE = 'MERGE_FAILURE'

export const LOAD_EXAMHISTORY_REQUEST = 'LOAD_EXAMHISTORY_REQUEST'
export const LOAD_EXAMHISTORY_SUCCESS = 'LOAD_EXAMHISTORY_SUCCESS'
export const LOAD_EXAMHISTORY_FAILURE = 'LOAD_EXAMHISTORY_FAILURE'

export const LOAD_EXAMPRODUCTHISTORY_REQUEST = 'LOAD_EXAMPRODUCTHISTORY_REQUEST'
export const LOAD_EXAMPRODUCTHISTORY_SUCCESS = 'LOAD_EXAMPRODUCTHISTORY_SUCCESS'
export const LOAD_EXAMPRODUCTHISTORY_FAILURE = 'LOAD_EXAMPRODUCTHISTORY_FAILURE'

export const SET_INTERNET_FAILURE = 'SET_INTERNET_FAILURE'

export const LOAD_HOME_COURSE_ALL_REQUEST = 'LOAD_HOME_COURSE_ALL_REQUEST'
export const LOAD_HOME_COURSE_ALL_SUCCESS = 'LOAD_HOME_COURSE_ALL_SUCCESS'
export const LOAD_HOME_COURSE_ALL_FAILURE = 'LOAD_HOME_COURSE_ALL_FAILURE'

export const LOAD_TESTEXAMOVERVIEW_REQUEST = 'LOAD_TESTEXAMOVERVIEW_REQUEST'
export const LOAD_TESTEXAMOVERVIEW_SUCCESS = 'LOAD_TESTEXAMOVERVIEW_SUCCESS'
export const LOAD_TESTEXAMOVERVIEW_FAILURE = 'LOAD_TESTEXAMOVERVIEW_FAILURE'

export const LOAD_ARTICLE_REQUEST = 'LOAD_ARTICLE_REQUEST'
export const LOAD_ARTICLE_SUCCESS = 'LOAD_ARTICLE_SUCCESS'
export const LOAD_ARTICLE_FAILURE = 'LOAD_ARTICLE_FAILURE'

export const LOAD_HISTORYTESTEXAM_REQUEST = 'LOAD_HISTORYTESTEXAM_REQUEST'
export const LOAD_HISTORYTESTEXAM_SUCCESS = 'LOAD_HISTORYTESTEXAM_SUCCESS'
export const LOAD_HISTORYTESTEXAM_FAILURE = 'LOAD_HISTORYTESTEXAM_FAILURE'

export const PAYMENT_DEKNERD_PAYFORU_REQUEST = 'PAYMENT_DEKNERD_PAYFORU_REQUEST'
export const PAYMENT_DEKNERD_PAYFORU_SUCCESS = 'PAYMENT_DEKNERD_PAYFORU_SUCCESS'
export const PAYMENT_DEKNERD_PAYFORU_FAILURE = 'PAYMENT_DEKNERD_PAYFORU_FAILURE'

export const PAYMENT_PAYFORU_REQUEST = 'PAYMENT_PAYFORU_REQUEST'
export const PAYMENT_PAYFORU_SUCCESS = 'PAYMENT_PAYFORU_SUCCESS'
export const PAYMENT_PAYFORU_FAILURE = 'PAYMENT_PAYFORU_FAILURE'

export const LOAD_PACKAGE_PAGES_FAILURE = 'LOAD_PACKAGE_PAGES_FAILURE'
export const LOAD_PACKAGE_PAGES_REQUEST = 'LOAD_PACKAGE_PAGES_REQUEST'
export const LOAD_PACKAGE_PAGES_SUCCESS = 'LOAD_PACKAGE_PAGES_SUCCESS'

export const CHECK_PAYMENT_STATUS_FAILURE = 'CHECK_PAYMENT_STATUS_FAILURE'
export const CHECK_PAYMENT_STATUS_REQUEST = 'CHECK_PAYMENT_STATUS_REQUEST'
export const CHECK_PAYMENT_STATUS_SUCCESS = 'CHECK_PAYMENT_STATUS_SUCCESS'

export const LOAD_PACKAGE_FAILURE = 'LOAD_PACKAGE_FAILURE'
export const LOAD_PACKAGE_REQUEST = 'LOAD_PACKAGE_REQUEST'
export const LOAD_PACKAGE_SUCCESS = 'LOAD_PACKAGE_SUCCESS'

export const LOAD_BANNERALL_REQUEST = 'LOAD_BANNERALL_REQUEST'
export const LOAD_BANNERALL_SUCCESS = 'LOAD_BANNERALL_SUCCESS'
export const LOAD_BANNERALL_FAILURE = 'LOAD_BANNERALL_FAILURE'

export const LOAD_LIVE_PAGE_REQUEST = 'LOAD_LIVE_PAGE_REQUEST'
export const LOAD_LIVE_PAGE_SUCCESS = 'LOAD_LIVE_PAGE_SUCCESS'
export const LOAD_LIVE_PAGE_FAILURE = 'LOAD_LIVE_PAGE_FAILURE'

export const LOAD_LIVE_REPLAY_REQUEST = 'LOAD_LIVE_REPLAY_REQUEST'
export const LOAD_LIVE_REPLAY_SUCCESS = 'LOAD_LIVE_REPLAY_SUCCESS'
export const LOAD_LIVE_REPLAY_FAILURE = 'LOAD_LIVE_REPLAY_FAILURE'

export const LOAD_LIVE_NOW_REQUEST = 'LOAD_LIVE_NOW_REQUEST'
export const LOAD_LIVE_NOW_SUCCESS = 'LOAD_LIVE_NOW_SUCCESS'
export const LOAD_LIVE_NOW_FAILURE = 'LOAD_LIVE_NOW_FAILURE'

export const LOAD_LIVE_COMING_REQUEST = 'LOAD_LIVE_COMING_REQUEST'
export const LOAD_LIVE_COMING_SUCCESS = 'LOAD_LIVE_COMING_SUCCESS'
export const LOAD_LIVE_COMING_FAILURE = 'LOAD_LIVE_COMING_FAILURE'

export const SAVE_HISTORY_CHAT_REQUEST = 'SAVE_HISTORY_CHAT_REQUEST'
export const SAVE_HISTORY_CHAT_SUCCESS = 'SAVE_HISTORY_CHAT_SUCCESS'
export const SAVE_HISTORY_CHAT_FAILURE = 'SAVE_HISTORY_CHAT_FAILURE'

export const LOAD_LIVEDETAIL_REQUEST = 'LOAD_LIVEDETAIL_REQUEST'
export const LOAD_LIVEDETAIL_SUCCESS = 'LOAD_LIVEDETAIL_SUCCESS'
export const LOAD_LIVEDETAIL_FAILURE = 'LOAD_LIVEDETAIL_FAILURE'

export const LOAD_REVIEWLIVE_REQUEST = 'LOAD_REVIEWLIVE_REQUEST'
export const LOAD_REVIEWLIVE_SUCCESS = 'LOAD_REVIEWLIVE_SUCCESS'
export const LOAD_REVIEWLIVE_FAILURE = 'LOAD_REVIEWLIVE_FAILURE'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export const LOAD_SCHEDULE_REQUEST = 'LOAD_SCHEDULE_REQUEST'
export const LOAD_SCHEDULE_SUCCESS = 'LOAD_SCHEDULE_SUCCESS'
export const LOAD_SCHEDULE_FAILURE = 'LOAD_SCHEDULE_FAILURE'

export const CLEAR_QRCODE_SUCCESS = 'CLEAR_QRCODE_SUCCESS'

export const LOAD_CATEGORYCREATOR_REQUEST = 'LOAD_CATEGORYCREATOR_REQUEST'
export const LOAD_CATEGORYCREATOR_SUCCESS = 'LOAD_CATEGORYCREATOR_SUCCESS'
export const LOAD_CATEGORYCREATOR_FAILURE = 'LOAD_CATEGORYCREATOR_FAILURE'

export const LOAD_LESSON_REQUEST = 'LOAD_LESSON_REQUEST'
export const LOAD_LESSON_SUCCESS = 'LOAD_LESSON_SUCCESS'
export const LOAD_LESSON_FAILURE = 'LOAD_LESSON_FAILURE'

export const SAVE_LESSON_REQUEST = 'SAVE_LESSON_REQUEST'
export const SAVE_LESSON_SUCCESS = 'SAVE_LESSON_SUCCESS'
export const SAVE_LESSON_FAILURE = 'SAVE_LESSON_FAILURE'

export const TUTOR_REQUEST = 'TUTOR_REQUEST'
export const TUTOR_SUCCESS = 'TUTOR_SUCCESS'
export const TUTOR_FAILURE = 'TUTOR_FAILURE'

export const LOAD_LISTTUTOR_REQUEST = 'LOAD_LISTTUTOR_REQUEST'
export const LOAD_LISTTUTOR_SUCCESS = 'LOAD_LISTTUTOR_SUCCESS'
export const LOAD_LISTTUTOR_FAILURE = 'LOAD_LISTTUTOR_FAILURE'



// WEBPACK FOOTER //
// ./src/actions/types.js